export default __webpack_public_path__ + "static/Digital-HP-Unbranded-Patient-Tearsheet-06166a824ee8c7053af40917fe8e73c3.jpg";